import { Component, Input } from '@angular/core';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { ClientAccountType, ContentScoringMethod } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-scoring-method-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './scoring-method-field.component.html',
	styleUrl: './scoring-method-field.component.scss',
})
export class ScoringMethodFieldComponent extends BaseFieldComponent {
	//convert the value of the ContentScoringMethod enum to DropdownOption
	public options: DropdownOption[] = Object.keys(ContentScoringMethod).map(key => {
		return { value: key, label: key };
	});
}
